//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 组件使用文档: https://tdesign.woa.com/vue/components/upload?tab=demo
import { CosMixin } from '@/mixins/cos';
const defaultConfig = {
  bgcImgUrl:
    'https://static1.baike.qq.com/2022125/a85b39e0-79f6-11ed-89ce-4ff3ab5f0cf9_0.png',
  top: '-50px',
  left: '0px',
  logoWidth: '120px',
  logoHeight: '120px',
};
export default {
  mixins: [CosMixin],
  props: {
    file: {
      type: Array,
      default: () => {
        return [];
      },
    },
    theme: {
      type: String,
      default: 'image',
    },
    max: {
      type: Number,
      default: 1,
    },
    tip: {
      type: String,
      default: '文件尺寸建议136*46px，文件格式不限，最多只能上传 1 份文件',
    },
    config: {
      type: Object,
      default: () => {
        return {
          ...defaultConfig,
        };
      },
    },
  },
  data() {
    return {
      isERR: false,
      fileObj: null,
      visible: false,
    };
  },
  computed: {
    fileList: {
      get() {
        return this.file;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    temporaryUrl() {
      return this.fileList.map((item) => {
        return item.url || item.tempUrl;
      });
    },
  },
  methods: {
    init(file) {
      this.file = file;
    },
    getData() {
      console.log(this.file);
      console.log(this.fileObj);
      console.log(this.url);
    },
    handleFail({ file }) {
      this.$message.error(`文件 ${file.name} 上传失败`);
    },
    remove({ index: delIndex }) {
      this.fileList = this.fileList.filter((item, index) => {
        return index !== delIndex;
      });
    },
    // 上传前处理
    httpRequest(file) {
      let fileList = [file];
      if (Array.isArray(file)) {
        fileList = file;
      }
      console.log('fileList:', fileList);
      let isSupport = true;

      const fileObj = fileList.reduce((pre, item) => {
        const regExp = 'PNG|JPG|JPEG|BMP|GIF';
        if (!new RegExp(`(${regExp})`, 'i').test(item.type)) {
          this.$message.error(`上传图片仅支持${regExp}格式!`);
          isSupport = false;
          return pre;
        }

        if (file.size / 1024 / 1024 > 10) {
          this.$message.error('上传图片大小不能超过10MB!');
          return pre;
        }
        return [
          ...pre,
          {
            file: item.raw,
            cos_status: 'ready', // cos上传状态 ready(准备上传) error(上传错误) success(上传成功)
            upload_status: 'ready', // 服务器上传状态 ready(准备上传) error(上传错误) success(上传成功)
            tempUrl: URL.createObjectURL(item.raw), // 临时地址
            url: URL.createObjectURL(item.raw), // cos地址
          },
        ];
      }, []);
      this.fileList = fileObj;
      if (isSupport) {
        this.isERR = false;
        const fileObj = fileList[fileList.length - 1];
        return new Promise((resolve) => {
          return resolve({
            status: 'success',
            response: {
              name: fileObj.name,
              url: URL.createObjectURL(fileObj.raw),
            },
          });
        });
      }
      this.isERR = true;
      return new Promise((resolve) => {
        return resolve({ status: 'fail', error: '上传失败' });
      });
    },
    // 上传转换获取cos地址
    getCosUrl() {
      return new Promise(async (resolve) => {
        const item = this.fileList[0];
        // 准备上传和上传失败可再上传
        if (item?.cos_status === 'ready' || item?.cos_status === 'error') {
          const cosParams = {
            fileObject: item.file,
          };
          try {
            const res = await this.putCosObject(cosParams);
            console.log('执行了--->', res);
            item.url = res.data;
            item.cos_status = res ? 'success' : 'error';
            resolve([item]);
          } catch (error) {
            item.cos_status = 'error';
          }
        } else {
          resolve([item]);
        }
      });
    },
    view() {
      this.$emit('view', URL.createObjectURL(this.fileObj.file));
    },
  },
};
